import PropTypes from 'prop-types';
import React from 'react';
import createHeartComponent from '@finn-no/favorite-heart-component';
import { useDataContext } from 'common/lib/helpers/DataContext';
import { useDeviceSize } from 'common/lib/hooks/useDeviceSize';

const SaveAd = ({ variant }) => {
    const { finnkode, userId } = useDataContext();
    const { isMobile } = useDeviceSize();

    const Heart = createHeartComponent({
        userId,
    });

    return <Heart itemType="Ad" itemId={finnkode} isMobile={isMobile} variant={variant} />;
};

SaveAd.propTypes = {
    variant: PropTypes.string,
};

export default SaveAd;
